import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";

import { useEffect } from "react";

import {
    Bold,
    Italic,
    Underline as UnderlineIcon,
    Heading1,
    Heading2,
    List,
    ListOrdered,
    Quote,
    Code,
    Undo,
    Redo,
    Link as LinkIcon,
    Minus,
    AlignLeft,
    AlignCenter,
    AlignRight,
    RemoveFormatting
} from "lucide-react";


export default function TemplateEditor({ value, onChange }) {

    const editor = useEditor({

        extensions: [

            StarterKit,

            Underline,

            Link.configure({
                openOnClick: false
            }),

            TextAlign.configure({
                types: [
                    "heading",
                    "paragraph"
                ]
            })

        ],

        content: value || "",


        onUpdate({ editor }) {

            onChange(editor.getHTML());

        }

    });



    useEffect(() => {

        if (
            editor &&
            value !== editor.getHTML()
        ) {

            editor.commands.setContent(value || "");

        }

    }, [value, editor]);



    if (!editor) return null;



    const addLink = () => {

        const url = window.prompt(
            "Enter URL"
        );

        if (url) {

            editor
                .chain()
                .focus()
                .setLink({
                    href: url
                })
                .run();

        }

    };



    const Button = ({
        children,
        onClick,
        active
    }) => (

        <button

            type="button"

            className={
                active
                ? "toolbar-btn active"
                : "toolbar-btn"
            }

            onClick={onClick}

        >

            {children}

        </button>

    );



    return (

        <div className="template-editor">


            <div
                className="toolbar"
            >


                <Button
                    active={editor.isActive("bold")}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleBold()
                        .run()
                    }
                >
                    <Bold size={18}/>
                </Button>



                <Button
                    active={editor.isActive("italic")}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleItalic()
                        .run()
                    }
                >
                    <Italic size={18}/>
                </Button>



                <Button
                    active={editor.isActive("underline")}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleUnderline()
                        .run()
                    }
                >
                    <UnderlineIcon size={18}/>
                </Button>



                <Button
                    active={editor.isActive("heading", {
                        level:1
                    })}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleHeading({
                            level:1
                        })
                        .run()
                    }
                >
                    <Heading1 size={18}/>
                </Button>



                <Button
                    active={editor.isActive("heading", {
                        level:2
                    })}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleHeading({
                            level:2
                        })
                        .run()
                    }
                >
                    <Heading2 size={18}/>
                </Button>



                <Button
                    active={editor.isActive("bulletList")}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleBulletList()
                        .run()
                    }
                >
                    <List size={18}/>
                </Button>



                <Button
                    active={editor.isActive("orderedList")}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleOrderedList()
                        .run()
                    }
                >
                    <ListOrdered size={18}/>
                </Button>



                <Button
                    active={editor.isActive("blockquote")}
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleBlockquote()
                        .run()
                    }
                >
                    <Quote size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .toggleCodeBlock()
                        .run()
                    }
                >
                    <Code size={18}/>
                </Button>



                <Button
                    onClick={addLink}
                >
                    <LinkIcon size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .setHorizontalRule()
                        .run()
                    }
                >
                    <Minus size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .setTextAlign("left")
                        .run()
                    }
                >
                    <AlignLeft size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .setTextAlign("center")
                        .run()
                    }
                >
                    <AlignCenter size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .setTextAlign("right")
                        .run()
                    }
                >
                    <AlignRight size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .undo()
                        .run()
                    }
                >
                    <Undo size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .redo()
                        .run()
                    }
                >
                    <Redo size={18}/>
                </Button>



                <Button
                    onClick={() =>
                        editor.chain()
                        .focus()
                        .clearNodes()
                        .unsetAllMarks()
                        .run()
                    }
                >
                    <RemoveFormatting size={18}/>
                </Button>


            </div>



            <EditorContent

                editor={editor}
                

                className="editor-content"

            />

        </div>

    );

}